var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningInitialOfffer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 88,
    viewBox: "0 0 89 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 88,
    height: 88,
    rx: 44,
    fill: "#FF9F43",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.4994 37V46.3333M44.4994 55.6667H44.5228M41.2685 25.0807L22.0771 58.2295C21.0126 60.0681 20.4804 60.9874 20.5591 61.7419C20.6277 62.4001 20.9725 62.9981 21.5076 63.3872C22.1212 63.8333 23.1835 63.8333 25.308 63.8333H63.6908C65.8154 63.8333 66.8777 63.8333 67.4912 63.3872C68.0264 62.9981 68.3712 62.4001 68.4398 61.7419C68.5185 60.9874 67.9862 60.0681 66.9218 58.2295L47.7304 25.0807C46.6697 23.2486 46.1394 22.3326 45.4475 22.0249C44.8439 21.7566 44.1549 21.7566 43.5514 22.0249C42.8595 22.3326 42.3292 23.2486 41.2685 25.0807Z",
    stroke: "#FF9F43",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningInitialOfffer);
export default __webpack_public_path__ + "static/media/warningInitialOfffer.598dc157e90b05f3c36db30eb92f6c17.svg";
export { ForwardRef as ReactComponent };